import { Col, Row } from "reactstrap";
import OverviewHeader from "../../../overview-header";
import FindingsList from "./components/FindingsList";

const Findings = ({
    assetId
}) => {
    return (
        <div className="p-4">
            <Row>
                <Col className="pb-4">
                    <OverviewHeader
                        assetId={assetId}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <FindingsList
                        assetId={assetId}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Findings; 